import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const DOB_INPUT_FORMAT = 'DD.MM.YYYY';
const DOB_API_FORMAT = 'YYYY-MM-DD';
const DOB_MIN_YEAR = 1900;

function getDigits(value) {
  return String(value || '').replace(/\D/g, '');
}

function parseDateOfBirth(value) {
  const normalizedValue = String(value || '').trim();

  if (!normalizedValue) {
    return null;
  }

  const apiDate = dayjs(normalizedValue.slice(0, 10), DOB_API_FORMAT, true);

  if (apiDate.isValid()) {
    return apiDate;
  }

  const inputDate = dayjs(normalizedValue, DOB_INPUT_FORMAT, true);

  return inputDate.isValid() ? inputDate : null;
}

export function hasDateOfBirthInputValue(value) {
  return getDigits(value).length > 0;
}

export function formatDateOfBirthInput(value) {
  const parsedDate = parseDateOfBirth(value);

  if (parsedDate) {
    return parsedDate.format(DOB_INPUT_FORMAT);
  }

  const digits = getDigits(value).slice(0, 8);

  if (digits.length <= 2) {
    return digits;
  }

  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  }

  return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
}

export function normalizeDateOfBirthApiValue(value) {
  const parsedDate = parseDateOfBirth(value);

  return parsedDate ? parsedDate.format(DOB_API_FORMAT) : '';
}

export function isDateOfBirthValid(value) {
  const parsedDate = parseDateOfBirth(value);

  return Boolean(parsedDate)
    && parsedDate.year() >= DOB_MIN_YEAR
    && parsedDate.isBefore(dayjs(), 'day');
}

export function getDateOfBirthApiValue(value) {
  return isDateOfBirthValid(value) ? normalizeDateOfBirthApiValue(value) : '';
}

export function formatDateOfBirthDisplay(value) {
  const parsedDate = parseDateOfBirth(value);

  return parsedDate ? parsedDate.format(DOB_INPUT_FORMAT) : '';
}
